"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ExternalWhatsAppIcon = void 0;
var React = _interopRequireWildcard(require("react"));
var _SvgIcon = require("../SvgIcon");
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function (e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != typeof e && "function" != typeof e) return {
    default: e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
    var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
    i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
  }
  return n.default = e, t && t.set(e, n), n;
}
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
} /**
  * This file was generated by the build:icons script
  * See Notion for details on how to add icons
  */
const ExternalWhatsAppIcon = props => /*#__PURE__*/React.createElement(_SvgIcon.SvgIcon, _extends({}, props, {
  viewBox: "0 0 24 24"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M19.232 4.761A9.42 9.42 0 0 0 12.54 2C7.325 2 3.08 6.223 3.08 11.414c-.002 1.66.434 3.28 1.262 4.707L3 21l5.015-1.31a9.484 9.484 0 0 0 4.52 1.147h.005c5.214 0 9.458-4.224 9.46-9.415a9.335 9.335 0 0 0-2.768-6.661ZM12.54 19.247h-.003a7.882 7.882 0 0 1-4.002-1.091l-.288-.17-2.976.777.795-2.888-.187-.296a7.778 7.778 0 0 1-1.202-4.164C4.678 7.1 8.206 3.59 12.543 3.59c2.1 0 4.074.816 5.56 2.295a7.758 7.758 0 0 1 2.3 5.536c-.002 4.315-3.53 7.826-7.863 7.826Zm4.313-5.861c-.237-.118-1.399-.687-1.616-.765-.216-.08-.374-.118-.531.117-.157.236-.61.766-.748.923-.138.157-.276.176-.513.058-.236-.118-.998-.366-1.9-1.167-.703-.624-1.178-1.394-1.316-1.63-.138-.236-.014-.363.104-.48.106-.105.236-.275.354-.412.119-.137.158-.236.237-.392.079-.157.04-.295-.02-.412-.059-.118-.531-1.276-.729-1.747-.192-.459-.387-.396-.531-.404a9.599 9.599 0 0 0-.454-.008.87.87 0 0 0-.63.294c-.217.236-.827.805-.827 1.963s.846 2.276.965 2.433c.118.157 1.667 2.533 4.038 3.553.564.242 1.004.387 1.348.495.566.18 1.081.154 1.488.094.454-.068 1.399-.57 1.596-1.119.197-.55.197-1.02.138-1.118-.06-.1-.217-.159-.453-.276Z"
}));
exports.ExternalWhatsAppIcon = ExternalWhatsAppIcon;